import {
  Flex,
  Text,
  Stack,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Button,
  Container,
  Show,
  useMediaQuery,
  Grid,
  GridItem,
} from "@chakra-ui/react";
import AvsCard from "@components/AVS/AvsCard";
import AvsRibbonGrid from "@components/AVS/AvsRibbonGrid";
import { TAvsCardData } from "@components/AVS/types";
import AVS_CMS_DATA from "@files/avs.json";
import { useRef, useState } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import { numberToCurrency } from "utils";

const AVS = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isLargerThan768] = useMediaQuery("(min-width: 769px)");
  const searchRef = useRef<string>("");

  const avsData: TAvsCardData[] = AVS_CMS_DATA.avs_data.map((item) => ({
    address: item.address,
    title: item.avs_details.title,
    desc: item.avs_details.description,
    imgUrl: item.avs_details.img_key,
    amtDel: 0,
    rewards: isNaN(Number(item.rewards))
      ? item.rewards
      : numberToCurrency(item.rewards),
  }));

  const filteredData = avsData.filter((item) =>
    item.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleInput = (e: any) => {
    searchRef.current = (e.target as any).value;
  };

  return (
    <Flex direction={"column"} px={2}>
      <Show below="md">
        <Flex px={5} justifyContent={"space-around"} gap={6} mb={4}>
          <AvsRibbonGrid />
        </Flex>
      </Show>
      <Container
        maxW="1512px"
        w="full"
        justifyContent="space-between"
        // p={{ base: "16px", md: "24px 40px" }}
        alignItems="center"
      >
        {isLargerThan768 && (
          <Flex px={10} gap={20} p={{ base: "16px", md: "24px 40px" }}>
            <AvsRibbonGrid />
          </Flex>
        )}
        <Flex
          gap="8px"
          direction={{ base: "column", md: "row" }}
          justifyContent="space-between"
        >
          <Flex alignItems={"flex-end"}>
            <Text
              fontSize={{ base: "18px", md: "24px", lg: "24px" }}
              lineHeight="43px"
              fontWeight="700"
            >
              Actively Validated Services ({avsData.length})
            </Text>
          </Flex>
          <Flex>
            <Stack spacing={6} width={"100%"}>
              <InputGroup minWidth={"320px"}>
                <InputLeftElement pointerEvents="none" pt="10px" px={"10px"}>
                  <AiOutlineSearch />
                </InputLeftElement>
                <Input
                  type="text"
                  placeholder="Search by name..."
                  borderRadius={50}
                  backgroundColor={"#F5F5F7"}
                  border="1px solid #A1B6BA"
                  p="24px 40px 24px"
                  size="sm"
                  onChange={handleInput}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      setSearchQuery(searchRef.current);
                    }
                  }}
                />
                <Show above="md">
                  <InputRightElement>
                    <Button
                      backgroundColor="#075A5A"
                      color="white"
                      borderRadius="50"
                      mt={2.5}
                      ml="-57px"
                      position={"absolute"}
                      p="24px 18px 22px"
                      onClick={() => setSearchQuery(searchRef.current)}
                    >
                      Search
                    </Button>
                  </InputRightElement>
                </Show>
              </InputGroup>
            </Stack>
          </Flex>
        </Flex>
        <Grid
          gap={5}
          marginX="auto"
          pt={5}
          gridTemplateColumns="repeat(auto-fill, minmax(330px, 1fr))"
        >
          {filteredData.length > 0
            ? filteredData.map((item: TAvsCardData, idx: number) => {
                return (
                  <GridItem key={idx}>
                    <AvsCard cardData={item} />
                  </GridItem>
                );
              })
            : avsData.map((item: TAvsCardData, idx: number) => {
                return (
                  <GridItem key={idx}>
                    <AvsCard cardData={item} />
                  </GridItem>
                );
              })}
        </Grid>
      </Container>
    </Flex>
  );
};

export default AVS;
